var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-4",attrs:{"color":this.primaryColor,"icon":""},on:{"click":function($event){return _vm.click()}}},[_c('v-icon',{attrs:{"x-large":"","name":"icon"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }